import { IconVariant } from '@/components/icons/types';
import { APP_ROUTES } from '@/constants/pages';

export enum AccountNavItemIdentifier {
  Profile = 'profile',
  Favorites = 'favorites',
  Bookings = 'bookings',
  PaymentMethods = 'payment-methods',
  Bundles = 'bundles',
}

export type AccountNavItem = {
  to?: (typeof APP_ROUTES)[keyof typeof APP_ROUTES];
  label?: string;
  identifier: AccountNavItemIdentifier;
  icon?: IconVariant;
};
